function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
export class EnterSubmitter extends React.PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "ref", /*#__PURE__*/React.createRef());
    _defineProperty(this, "listener", null);
    _defineProperty(this, "unsubscribe", () => {
      if (!this.listener) {
        return;
      }

      // @ts-ignore
      window.removeEventListener('keydown', this.listener);
    });
    _defineProperty(this, "subscribe", () => {
      // @ts-ignore
      this.listener = event => {
        if (event.defaultPrevented) {
          return;
        }
        switch (event.key) {
          case 'Enter':
            this.props.onEnter && this.props.onEnter();
            break;
          default:
            return;
        }
        event.preventDefault();
      };

      // @todo. auto generated. fix this error
      // @ts-ignore
      window.addEventListener('keydown', this.listener);
    });
  }
  componentDidMount() {
    this.subscribe();
  }
  componentWillUnmount() {
    this.unsubscribe();
  }
  render() {
    return this.props.children;
  }
}